import { useCallback, useEffect } from 'react';

export const useAutoFocusOnMount = ({ autoFocusClass = 'js-autofocus' }: { autoFocusClass?: string } = {}) => {
	const autoFocus = useCallback(() => {
		if (typeof document === 'undefined') return;

		// Get all elements with the autofocus class
		const elements: NodeListOf<HTMLInputElement> = document.querySelectorAll(`.${autoFocusClass}`);

		const inputElements = Array.from(elements).filter(el => el?.tagName?.toLowerCase() === 'input');

		// If there are no <input /> elements with the autofocus class
		// search for input elements within the non-input elements having the autofocus class
		if (inputElements.length === 0) {
			const nonInputElements: Array<HTMLElement> = Array.from(elements).filter(
				el => el?.tagName?.toLowerCase() !== 'input'
			);

			nonInputElements.forEach((element: HTMLElement) => {
				if (element?.tagName?.toLowerCase() !== 'input') {
					const newInputs = element?.querySelectorAll('input');

					inputElements.push(...Array.from(newInputs));
				}
			});
		}

		// If there are no input elements with the autofocus class
		if (inputElements.length === 0) return;

		// Get the first input element with the autofocus class
		const firstInputWithAutoFocus = inputElements[0];

		// and focus on this input element
		if (firstInputWithAutoFocus?.tagName?.toLowerCase() === 'input') {
			firstInputWithAutoFocus.focus();
			// console.debug('AutoFocus input', firstInputWithAutoFocus);

			if (firstInputWithAutoFocus.value === '') {
				firstInputWithAutoFocus.select();
			}
		}
	}, []);

	useEffect(() => {
		setTimeout(() => {
			autoFocus();
		}, 100);
	}, [autoFocus]);
};
